export default __webpack_public_path__ + "static/media/the_finance_sg.4b4fff70.png";